import { Component,
         OnChanges,
         ElementRef,
         ViewEncapsulation,
         Input,
         Output,
         EventEmitter
} from '@angular/core';
let jQuery = require('jquery');
let cytoscape = require('cytoscape');
import { AddGraphMenus } from './vca-graph-menus.cytoscape';
import { AddGraphTips } from './vca-graph-qtip.cytoscape';
import { AddAutoMove } from './vca-graph-automove.cytoscape';
import { AddPanZoom } from './vca-graph-panzoom.cytoscape';

let fileSaver = require('file-saver');
@Component({
    selector: 'vca-graph',
    template: '<div id="cy"></div>',
    styles: [require('./vca-graph.scss')],
    encapsulation: ViewEncapsulation.None
})


export class VcaGraph implements OnChanges {

    @Input() public elements: any;
    @Input() public style: any;
    @Input() public layout: any;
    @Input() public zoom: any;
    @Input() public menu: any;
    @Input() public tips: any;

    @Output() onZoom  = new EventEmitter<any>();
    @Output() onPan = new EventEmitter<any>();
    @Output() onAdd  = new EventEmitter<any>();
    @Output() onRemove = new EventEmitter<any>();
    @Output() onPositionChange = new EventEmitter<any>();
    @Output() onCleanUp = new EventEmitter<any>();

    cy;
    zoomDefaults = {
        zoomFactor: 0.05, // zoom factor per zoom tick
        zoomDelay: 45, // how many ms between zoom ticks
        minZoom: 0.1, // min zoom level
        maxZoom: 3, // max zoom level
        fitPadding: 50, // padding when fitting
        panSpeed: 10, // how many ms in between pan ticks
        panDistance: 10, // max pan distance per tick
        panDragAreaSize: 75, // the length of the pan drag box in which the vector for panning is calculated (bigger = finer control of pan speed and direction)
        panMinPercentSpeed: 0.25, // the slowest speed we can pan by (as a percent of panSpeed)
        panInactiveArea: 8, // radius of inactive area in pan drag box
        panIndicatorMinOpacity: 0.5, // min opacity of pan indicator (the draggable nib); scales from this to 1.0
        zoomOnly: false, // a minimal version of the ui only with zooming (useful on systems with bad mousewheel resolution)
        fitSelector: undefined, // selector of elements to fit
        animateOnFit: function(){ // whether to animate on fit
            return false;
        },
        fitAnimationDuration: 1000, // duration of animation on fit
        sliderHandleIcon: 'minus',
        zoomInIcon: 'plus',
        zoomOutIcon: 'minus',
        resetIcon: 'expand'
    };

    public constructor(private el: ElementRef) {
        this.layout = this.layout || {
                name: 'preset',
                fit: true,
                padding: 60,
                avoidOverlap: true
            };

        this.zoom = this.zoom || {
                min: 0.1,
                max: 3
            };
    }

    public ngOnChanges(changes): any {
        this.render();
    }

    public ngOnDestroy(): any {
        this.cy = undefined;
        this.onCleanUp.emit();
    }

    public render() {
        this.cy = cytoscape({
            container: document.getElementById('cy'),
            layout: this.layout,
            renderer: 'svg',
            minZoom: this.zoom.min,
            maxZoom: this.zoom.max,
            style: this.style,
            elements: this.elements,
            zoomingEnabled: true,
            userZoomingEnabled: true,
            panningEnabled: true,
            userPanningEnabled: true,
            boxSelectionEnabled: false,
            selectionType: 'single',
            touchTapThreshold: 8,
            desktopTapThreshold: 4,
            autolock: false,
            autoungrabify: false,
            autounselectify: false
        });

        // Send custom events and listen to them to fix tooltip issues
        let hoverTimeout;
        let hoverDelay = 500;
        let hoverElt = this.cy.collection();

        this.cy.on('mouseover', 'node, .connection', function() {
            hoverElt = this;
            clearTimeout( hoverTimeout );
                hoverTimeout = setTimeout(function()  {
                    hoverElt.trigger('hover');
                }, hoverDelay);
             })
            .on('mouseout', 'node, .connection', function() {
                clearTimeout( hoverTimeout );
                hoverElt.trigger('hovercancel');
            });

        let isPanZoomExtensionRegistered = Object.getPrototypeOf(this.cy).PanZoom != null;
        if (!isPanZoomExtensionRegistered) {
            AddPanZoom();
            this.cy.PanZoom(this.zoomDefaults);
        }

        let isMenuExtensionRegistered = Object.getPrototypeOf(this.cy).GraphMenus != null;
        if (!isMenuExtensionRegistered) {
            AddGraphMenus();
        }

        let isTipExtensionRegistered = Object.getPrototypeOf(this.cy).GraphTips != null;
        let isQTipRegistered = Object.getPrototypeOf(this.cy).qtip != null;
        if (!isTipExtensionRegistered && !isQTipRegistered ) {
            AddGraphTips();
        }

        let isAutoMoveExtensionRegistered = Object.getPrototypeOf(this.cy).AutoMove != null;
        if (!isAutoMoveExtensionRegistered) {
            AddAutoMove();
        }

        this.cy.GraphMenus({
            menuItems: this.menu
        });

        this.tips.forEach(tip => {
            this.cy.elements(tip.selector).GraphTips(tip.contentAndStyle);
        });

        this.cy.$('.wrapper').ungrabify();
        this.cy.$('.wrapper').unselectify();

        this.cy.$('node').ungrabify();

        this.cy.on('zoom', (event) => {
            this.displayBlock();
            this.onZoom.emit(event);
        });

        this.cy.on('pan', (event) => {
            this.displayBlock();
            this.onPan.emit(event);
        });

        this.cy.on('add', (event) => {
            this.displayBlock();
            this.onAdd.emit(event);
            this.refreshZoom();
            this.tips.forEach(tip => {
                this.cy.elements(tip.selector).GraphTips(tip.contentAndStyle);
            });
            this.cy.$('node').ungrabify();
        });

        this.cy.on('remove', (event) => {
            this.displayBlock();
            this.onRemove.emit(event);
            this.refreshZoom();
        });

        this.cy.on('position', (event) => {
            this.displayBlock();
            this.onPositionChange.emit(event);
        });

        this.cy.on('tap', 'node', (event) => {

        });

        this.refreshZoom();
    }

    public refreshZoom() {
        this.cy.zoom(0.1);
        this.cy.animate({
            zoom: 0.6
        }, {
            duration: 1000
        });
        this.cy.PanZoom(this.zoomDefaults);
    }

    public displayBlock() {
        let id = this.getElements()[0] ? this.getElements()[0].data().id : 'cy';
        this.cy.$('#' + id).css('display', 'block');
    }

    public getElements() {
        return this.cy.elements();
    }

    public addElement( elementObj ) {
        this.cy.add([elementObj]);
    }

    public removeElement(elementObj) {
        this.cy.remove([elementObj]);
    }

    public modifyElement( elementId, json ) {
        let elem = this.cy.$('#' + elementId);
        elem.data(json);
    }

    public addNode( elementObj ) {
        elementObj.group = 'nodes';
        this.cy.add([elementObj]);
    }

    public addEdge( elementObj ) {
        elementObj.group = 'edges';
        this.cy.add([elementObj]);
    }

    public resizeElement( selector, width, height ) {
        this.cy.style().selector(selector).style('width', width).update();
        this.cy.style().selector(selector).style('height', height).update();
    }

    public rePositionNode(node, newPos ) {
        node.animate({
            position: newPos,
            },{
            duration: 1000
        });
    }

    public rePositionElement(selector, newPos ) {
        this.cy.$(selector).position(newPos);
    }

    public createAndDownloadImage(name, options) {
        /** The commented code below works but we can't set the file name and extension with this */
        /** Saving it for future reference */
        /**
            let png64 = this.cy.png();
            let img = document.getElementById('png-eg');
            img.src = png64;
            window.location.href = img.src.replace('image/png', 'image/octet-stream');
        */
        let b64key = 'base64,';
        let b64 = this.cy.png(options).substring(this.cy.png(options).indexOf(b64key) + b64key.length );
        let imgBlob = this.base64toBlob( b64, 'image/png' );
        fileSaver.saveAs( imgBlob, name );
    }

    public base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 1024;
        let byteCharacters = atob(base64Data);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (let offset = begin, i = 0 ; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-graph/vca-graph.cytoscape.ts